import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import "./App.css";

// Code-split all page routes
const Landing = lazy(() => import("./pages/Landing"));
const Login = lazy(() => import("./pages/Login"));
const Signup = lazy(() => import("./pages/Signup"));
const Onboarding = lazy(() => import("./pages/Onboarding"));
const MenuUpload = lazy(() => import("./pages/MenuUpload"));
const MenuReview = lazy(() => import("./pages/MenuReview"));
const DeliveryPreview = lazy(() => import("./pages/DeliveryPreview"));
const Payment = lazy(() => import("./pages/Payment"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const CompliancePage = lazy(() => import("./pages/CompliancePage"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" /></div>;
  if (user) return <Navigate to="/panel" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Suspense fallback={
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    }>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/giris" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/kayit" element={<PublicRoute><Signup /></PublicRoute>} />
      <Route path="/kurulum" element={<PrivateRoute><Onboarding /></PrivateRoute>} />
      <Route path="/menu-yukle" element={<PrivateRoute><MenuUpload /></PrivateRoute>} />
      <Route path="/onay" element={<PrivateRoute><MenuReview /></PrivateRoute>} />
      <Route path="/teslimat" element={<PrivateRoute><DeliveryPreview /></PrivateRoute>} />
      <Route path="/odeme" element={<PrivateRoute><Payment /></PrivateRoute>} />
      <Route path="/odeme/basarili" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
      <Route path="/panel" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/m/:slug" element={<CompliancePage />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
